<div class="scroll-container" #scrollContainer (wheel)="onWheel($event)">

    <app-top-bar class="desktop-top-bar"></app-top-bar>

    <div class="horizontal-layout">

        <div routerLink="/" id="mobile-arrow-back-to-homepage" class="only-mobile padding-mobile-left-right pointer">
            <a>
                <img src="img/legals/arrow-back.svg" alt="arrow back">
            </a>
        </div>

        @for (
        column of contentService.content().privacyPolicy.main;
        track column.header;
        let i = $index;
        let isFirst = $first;
        let isLast = $last;
        ) {
            @if (isFirst) {
            <h2>{{ contentService.content().privacyPolicy.title }}</h2>
            }
        <div #col [id]="'privacy-col-' + i" class="column">
            <div class="police-text" [innerHTML]="column"></div>

            @if (!isLast) {
            <app-switch-arrow (click)="scrollToElement(i + 1)">
            </app-switch-arrow>
            } @else {
            <app-footer [scrollContainer]="scrollContainer"></app-footer>
            }
        </div>
        }
    </div>
</div>